import * as Msal from '@azure/msal-browser';

// Microsoft Entra External ID (CIAM) configuration for OrcaWebsite's external
// (customer) sign-up/sign-in flow. This is separate from AuthConfig.ts, which
// is used exclusively for internal Odfjell staff sign-in against the regular
// Azure AD tenant.
//
// clientId and tenantSubdomain are read from public/assets/appsetting.json at
// runtime so the release pipeline can supply the correct values per environment
// (dev / qa / prod) without rebuilding the app.
export const buildExternalIdAuthConfig = (clientId: string, tenantSubdomain: string): Msal.Configuration => ({
    auth: {
        clientId,
        authority: `https://${tenantSubdomain}.ciamlogin.com/${tenantSubdomain}.onmicrosoft.com`,
        knownAuthorities: [`${tenantSubdomain}.ciamlogin.com`],
        redirectUri: '/signup',
        postLogoutRedirectUri: '/signup',
        // "External Manager" on the Login page (/login) can trigger loginExternal(), so the
        // request URL MSAL captures is often /login, not /signup. With this left
        // at its default (true), MSAL navigates the SPA back to that original
        // request URL after processing the redirect response - bouncing the user
        // back to /login even though the CIAM sign-in/sign-up itself succeeded.
        // /signup (the configured redirectUri) must always be the landing page,
        // regardless of where the external login was initiated from.
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loadFrameTimeout: 60000,
    },
});

export const externalIdScopes = ['openid', 'profile'];
